import React, { useState, useContext, useEffect } from 'react'

export const NavbarTheme = React.createContext({})

export const NavbarThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark')
  const [delay, setDelay] = useState(false)

  return (
    <NavbarTheme.Provider value={{ theme, setTheme, delay, setDelay }}>
      {children}
    </NavbarTheme.Provider>
  )
}

export const useNavbarTheme = (newTheme, newDelay) => {
  const state = useContext(NavbarTheme)

  useEffect(() => void state.setTheme(newTheme), [newTheme])
  useEffect(() => void state.setDelay(newDelay), [newDelay])

  return state
}
